import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import ddt from '@wix/da-ddt';
import { isSSR } from '../utils';
import biLogger from '@wix/da-bi/pkg/BiLogger.logger';
import { mergeEventDataWithContext } from '@wix/da-bi/pkg/hooks/useBiLogger';
class Taboola {
    logBi(eventData) {
        if (!this.biContext) {
            this.logQueue.push(eventData);
            return;
        }
        biLogger.log(this.publicSession, mergeEventDataWithContext(eventData, this.biContext), false);
        this.flushBiQueue();
    }
    flushBiQueue() {
        if (this.logQueue.length > 0) {
            for (const item of this.logQueue){
                biLogger.log(this.publicSession, mergeEventDataWithContext(item, this.biContext), false);
            }
            this.logQueue = [];
        }
    }
    init() {
        if (!isSSR()) {
            try {
            // TODO BI
            } catch (e) {
                ddt.alertOnError(e, 'ads', 'Fatal in ads BI', [
                    'ads'
                ], e.message);
            }
        }
    }
    registerUnit(unitId, options, safety) {
        if (safety === 'off') {
            ddt.log('ads', 'Skipped register because ads are OFF', unitId);
            return;
        }
        if (!isSSR()) {
            ddt.log('ads', 'register taboola client ad', unitId);
            window['_taboola'] = window['_taboola'] || [];
            window['_taboola'].push(_object_spread_props(_object_spread({}, options), {
                container: unitId,
                placement: unitId
            }));
            window['_taboola'].push({
                flush: true
            });
        } else {
            ddt.log('ads', 'register taboola ssr ad', unitId);
            this.ssrUnits[unitId] = _object_spread_props(_object_spread({}, options), {
                container: unitId,
                placement: unitId
            });
        }
    }
    killUnit(unitId) {
        // TODO cleanup units with API..
        const unit = Array.from(document.querySelectorAll(`#${unitId}`));
        unit.forEach((u)=>u.innerHTML = '');
    }
    toSSR() {
        const units = [];
        for (const key of Object.keys(this.ssrUnits)){
            const options = this.ssrUnits[key];
            units.push(`_taboola.push({
				mode: '${options.mode}',
				container: '${options.container}',
				placement: '${options.placement}',
				target_type: '${options.target_type}'
			});`);
        }
        return `${units.join('\n')}`;
    }
    setBiContext(context, session) {
        this.biContext = context;
        this.publicSession = session;
    }
    constructor(){
        _define_property(this, "ssrUnits", {});
        _define_property(this, "biContext", void 0);
        _define_property(this, "publicSession", void 0);
        _define_property(this, "logQueue", []);
    }
}
export default Taboola;
